import { APIClient } from './APIClient'

export const fetchTerrainAndTravelAdvice = (language) => {
    return APIClient.get(`/v1/${language}/statements/terrainAndTravel`, language)
}
